export function shortenUUID(uuid) {
  return `${uuid.slice(0, 3)}....${uuid.slice(-4)}`;
}
